<template>
  <div>
    <div
      v-if="isLoad"
      class="absolute w-full h-screen flex-col items-center flex justify-center"
    >
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
    <div class="flex" v-else>
      <v-col cols="8" class="px-0">
        <v-row v-show="isFeatureVisible('SHOW_ATTENDANCE_STATS')">
          <v-col @click="navToEmployee" class="cursor-pointer pr-0">
            <ReusableBox
              :number="statsData?.userClockInStats?.totalEmployees"
              :content="'Total Active Employees'"
              color="bg-indigo-500 dark:bg-[#4B5B9F]"
              class="py-4"
            />
          </v-col>
          <v-col class="cursor-pointer pr-0">
            <ReusableBox
              :number="statsData?.userClockInStats?.checkedInMembers"
              :content="isComplaintsEnabled ? 'Present' : 'Clocked-in'"
              color="bg-teal-500 dark:bg-[#2A9D8F]"
              class="py-4"
            />
          </v-col>
          <v-col class="cursor-pointer">
            <ReusableBox
              :number="statsData?.userClockInStats?.notCheckedInMembers"
              :content="isComplaintsEnabled ? 'Absent' : 'Not Clocked-in'"
              color="bg-red-500 dark:bg-[#D9534F]"
              class="py-4"
            />
          </v-col>
        </v-row>
        <v-row class="my-0">
          <v-col
            cols="12"
            class="relative pt-4"
            v-show="isItemTypeCase && isFeatureVisible('SHOW_CASE_ANALYTICS')"
          >
            <div class="absolute top-0 right-0 pr-3 pt-4" v-if="isItemTypeCase">
              <v-select
                class="w-64 pt-2"
                :items="subCasesOptions"
                v-model="selectedSubCase"
                dense
                label="Select Team"
                placeholder="Complaint Types"
                @change="handleChange"
              ></v-select>
            </div>
            <div
              class="mb-8"
              v-if="isItemTypeCase"
              v-show="isFeatureVisible('SHOW_CASE_ANALYTICS')"
            >
              <h2 class="ml-4 text-md my-3">{{ selectedSubCase }} Analytics</h2>
              <v-skeleton-loader
                v-if="!subCaseCharts"
                class="mx-auto"
                max-width="650"
                max-height="750"
                type="image"
              ></v-skeleton-loader>
              <apexchart
                v-else
                ref="apexChart"
                class="p-8 dark-text-color"
                type="bar"
                height="330"
                :options="subCaseCharts?.options"
                :series="subCaseCharts?.series"
              />
            </div>
          </v-col>
          <v-col
            v-if="!!caseTaskStats.options"
            cols="12"
            v-show="isItemTypeCase && isFeatureVisible('SHOW_CASE_ANALYTICS')"
          >
            <apexchart
              ref="apexChartCase"
              class="p-8 dark-text-color"
              type="bar"
              height="330"
              :options="caseTaskStats.options"
              :series="caseTaskStats.series"
            />
          </v-col>
          <v-col
            v-if="!!teleCallerStats.options"
            cols="12"
            v-show="
              isItemTypeCase &&
              isFeatureVisible('SHOW_CASE_ANALYTICS') &&
              isCustomerCallingEnable('CALL_A_CUSTOMER')
            "
          >
            <apexchart
              ref="apexChartTele"
              class="p-8 dark-text-color"
              type="bar"
              height="330"
              :options="teleCallerStats.options"
              :series="teleCallerStats.series"
            />
          </v-col>
          <v-col>
            <div v-show="!isItemTypeCase && complaintOptions.length">
              <v-select
                :items="complaintOptions"
                v-model="selectedComplaintType"
                outlined
                dense
                flat
                label="Complaint Types"
                placeholder="Complaint Types"
                @change="handleChange"
                clearable
              ></v-select>
            </div>
            <TaskColumn
              v-if="!loadingTasks && !isItemTypeCase"
              :tasks="tasks"
              :cases="cases"
              :data="statsData"
              :items="items"
              :itemType="itemType"
              :selectedUseCase="selectedUseCase"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <Progress
          :data="statsData"
          @selectedStat="fetchStatsData"
          :itemType="itemType"
          :subCasesOptions="subCasesOptions"
          :collectionVisits="collectionVisits"
        />
      </v-col>
    </div>
  </div>
</template>

<script>
import ReusableBox from "@/components/ReusableBox.vue";
import Progress from "@/components/Workforce/Dashboard/Progress.vue";
import TaskColumn from "@/components/Workforce/TaskColumn";
// import VueSsrCarousel from 'vue-ssr-carousel';
import {
  checkOrgCode,
  isModuleFeatureAllowed,
  isModuleVisible,
} from "@/utils/common";
export default {
  components: {
    ReusableBox,
    Progress,
    TaskColumn,
    apexchart: () =>
      typeof window !== "undefined" ? import("vue-apexcharts") : null,
  },
  layout: "Workforce/default",
  name: "WorkforceDashboardComponent",
  data() {
    return {
      loadingTasks: true,
      orgCode: this.$storage.getUniversal("organization_code"),
      userData: this.$storage.getUniversal("user"),
      enabledUseCase: this.$store.state.useCase,
      subCases: this.$store.state.subCases,
      tasks: [],
      cases: [],
      items: [],
      ChartOptions: {},
      selectedComplaintType: "",
      teleCallerStats: {},
      caseTaskStats: {},
      ChartSeries: [],
      collectionVisits: [],
      itemType: "case",
      statsData: {},
      subCaseCharts: {},
      complaintOptions: [],
      config: null,
      selectedOption: null,
      selectedUseCase: "",
      isLoad: true,
      isSelfieEnabled: false,
      selectedSubCase: null,
      darkMode: false,
      subCasesMapping: [],
    };
  },
  watch: {
    selectedSubCase(newValue) {
      if (!newValue) return;
      this.getConfig();

      this.fetchCaseAnalyticsStats(newValue);
      this.fetchTeleCallStats(newValue);
      this.fetchCaseTaskStats(newValue);
    },
    "$store.state.subCases": {
      handler(newSubCases) {
        this.subCases = newSubCases;
        if (this.subCasesOptions.length) {
          this.selectedSubCase = this.subCasesOptions[0];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    this.$root.$on("modeChange", this.modeChange);

    await this.fetchStatsData("CURRENT_DAY");
    await this.getConfig();
    await this.fetchData();
    this.isLoad = false;
  },
  computed: {
    isComplaintsEnabled() {
      return checkOrgCode(this.orgCode);
    },
    isItemTypeCase() {
      return isModuleVisible("COLLECTION_MANAGEMENT");
    },
    isInventoryCompliant() {
      return isModuleVisible("SELLS");
    },
    subCasesOptions() {
      const subCaseNames = [];

      if (this.subCases && Array.isArray(this.subCases)) {
        this.subCases.forEach((useCase) => {
          if (useCase.subCase && Array.isArray(useCase.subCase)) {
            let filteredSubCases = useCase.subCase;
            if (
              this.userData?.branch &&
              !this.userData?.role?.includes("WFM_ADMIN")
            ) {
              filteredSubCases = filteredSubCases.filter(
                (sub) => sub?.branch === this.userData?.branch
              );
            }

            filteredSubCases.forEach((subCase) => {
              if (subCase.name) {
                subCaseNames.push(subCase.name);
              }
            });
          }
        });
      }

      return subCaseNames;
    },
  },
  methods: {
    async modeChange() {
      if (localStorage.getItem("theme") === "dark") {
        this.darkMode = true;
      } else {
        this.darkMode = false;
      }

      await this.$nextTick();
      if (this.$refs.apexChart) {
        this.$refs.apexChart.updateOptions({
          theme: {
            mode: this.darkMode ? "dark" : "light",
          },
        });
      }
      if (this.$refs.apexChartCase) {
        this.$refs.apexChartCase.updateOptions({
          theme: {
            mode: this.darkMode ? "dark" : "light",
          },
        });
      }
      if (this.$refs.apexChartTele) {
        this.$refs.apexChartTele.updateOptions({
          theme: {
            mode: this.darkMode ? "dark" : "light",
          },
        });
      }
    },
    setStatOption(option) {
      this.selectedOption = option;
    },
    isFeatureVisible(feature) {
      return isModuleFeatureAllowed("DASHBOARD", feature);
    },
    isCustomerCallingEnable(feature) {
      return isModuleFeatureAllowed("ADDONS", feature);
    },
    async fetchCaseTaskStats(subCase) {
      try {
        const response = await this.$axios.get(
          `/workforce/collection/case/tasks/stats?caseType=${subCase}`
        );
        const categories = response.data?.data?.stats.map((d) => d._id);
        this.collectionVisits = response.data?.data?.tasks || [];

        const series = [
          {
            name: "No. of Visits",
            data: response.data.data?.stats.map((d) => d.count),
          },
        ];

        this.caseTaskStats = {
          options: {
            chart: {
              id: "casetask-stats",
              type: "bar",
              height: 350,
              toolbar: {
                show: false,
              },
            },
            xaxis: {
              categories: categories,
              title: {
                text: `${subCase} Visit Status`,
              },
            },
            yaxis: {
              title: {
                text: `#Visits`,
              },
            },
            plotOptions: {
              bar: {
                columnWidth: "45%",
                horizontal: false,
                endingShape: "rounded",
                dataLabels: {
                  position: "top",
                },
              },
            },
            colors: ["#1F5E9E", "#FFDE59", "#FF3131"],
            theme: {
              mode: this.darkMode ? "dark" : "light",
            },
          },
          series,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTeleCallStats(subCase) {
      try {
        const response = await this.$axios.get(
          `/workforce/tele-caller/stats?caseType=${subCase}`
        );
        const subCaseData = response.data.data.find((d) => d._id === subCase);
        const categories = [
          "Total calls",
          "Received by Agent",
          "Received by Customer",
        ];
        const series = [
          {
            name: "No. of Calls",
            data: [
              subCaseData?.totalCalls || 0,
              subCaseData?.aPartyConnectedCount || 0,
              subCaseData?.bPartyConnectedCount || 0,
            ],
          },
        ];

        this.teleCallerStats = {
          options: {
            chart: {
              id: "telecaller-stats",
              type: "bar",
              height: 350,
              toolbar: {
                show: false,
              },
            },
            xaxis: {
              categories: categories,
              title: {
                text: `${subCase} Call Status`,
              },
            },
            yaxis: {
              title: {
                text: `#Calls`,
              },
            },
            plotOptions: {
              bar: {
                columnWidth: "45%",
                horizontal: false,
                endingShape: "rounded",
                dataLabels: {
                  position: "top",
                },
              },
            },
            colors: ["#1F5E9E", "#FFDE59", "#FF3131"],
            theme: {
              mode: this.darkMode ? "dark" : "light",
            },
          },
          series,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        if (isModuleVisible("COLLECTION_MANAGEMENT")) {
          return;
        }

        const params = {
          start: this.$dayjs().format("YYYY-MM-DD"),
          limit: "*",
        };
        if (this.selectedComplaintType) {
          params.search = this.selectedComplaintType;
        }
        const response = await this.$axios.get("/workforce/task/org", {
          params,
        });
        this.items = response.data.tasks;
        this.itemType = "task";
      } catch (error) {
        console.error(error);
      }
      this.loadingTasks = false;
    },
    async fetchStatsData(selectedStat) {
      try {
        const params = {};
        if (selectedStat) {
          this.selectedUseCase = selectedStat?.useCase?.toLowerCase();
          params.pull = selectedStat?.period;
          params.useCase = selectedStat?.useCase?.toLowerCase();
        }
        const response = await this.$axios.get("workforce/org/stats", {
          params,
        });
        this.statsData = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    // async fetchAllCaseAnalyticsStats() {
    //   const subCases = this.subCasesOptions;
    //   for (const subCase of subCases) {
    //     await this.fetchCaseAnalyticsStats(subCase);
    //   }
    // },

    async fetchCaseAnalyticsStats(subCase) {
      try {
        const params = { caseType: subCase, fetch_type: "ORG" };
        const response = await this.$axios.get(
          "/workforce/collection/cases/analytics",
          {
            params,
          }
        );
        const caseAnalytics =
          response.data?.caseAnalytics?.userDefinedAnalytics;

        let categories =
          caseAnalytics.map(
            (data) =>
              `${data.userDefinedCaseStatus || "Un-Attended"} (${
                data.totalCount
              })`
          ) || [];

        let seriesData = caseAnalytics.map((data) => data.totalCount) || [0];

        this.subCaseCharts = {
          options: {
            chart: {
              type: "bar",
              height: 350,
              toolbar: {
                show: false,
              },
            },
            xaxis: {
              categories,
              title: {
                text: `${subCase} Status`,
              },
            },
            yaxis: {
              title: {
                text: `#Cases`,
              },
            },
            plotOptions: {
              bar: {
                columnWidth: "45%",
                horizontal: false,
                endingShape: "rounded",
                dataLabels: {
                  position: "top",
                },
              },
            },
            colors: ["#1F5E9E", "#FFDE59", "#FF3131"],
            theme: {
              mode: this.darkMode ? "dark" : "light",
            },
          },
          series: [
            {
              name: "Cases",
              data: seriesData,
            },
          ],
        };
      } catch (error) {
        console.log(error);
      }
    },
    async getConfig() {
      try {
        const response = await this.$axios.get("/workforce/org/config");

        const data = response.data?.config;
        this.complaintOptions = data.predefinedComplaintTitles;
        this.isSelfieEnabled =
          data.isCheckedInSelfie || data.isCheckedOutSelfie;
        this.subCasesMapping = data.enabledSubCases[0].subCase;
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    },
    navToEmployee() {
      this.$router.push("/workforce/employees");
    },
    async handleChange() {
      await this.fetchData();
    },
  },
};
</script>
